<template>
  <div>
    <header>
      <div class="header-inner">
        <h1>Boden Ryan</h1>
      </div>
      <!-- /.header-inner -->
    </header>
    <main>
      <section class="collection-container">
        <ul>
          <li v-for="gallery in galleries">
            <router-link :to="'/collection/'+gallery.ChildCollection.collection_id">
              <ul>
                <li>{{ gallery.ChildCollection.name }}</li>
                <li v-if="gallery.ChildCollection.ChildCount"><img src="../assets/images/images.svg" width="24" height="24" alt="">{{ gallery.ChildCollection.ChildCount.gallery }} galleries</li>
                <li v-else>Data locked</li>
                <li class="collection-gallery_link">View collection</li>
              </ul>
            </router-link>
          </li>
          </a>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>

  export default {
    name: 'collection',
    data () {
      return {
        galleries: null
      }
    },
    mounted () {

      // console.log(this.$route.name);
      // console.log(this.$route.params.id);
      
      var initEp = 'https://www.photoshelter.com/psapi/v3/collection/'+this.$route.params.id+'/children?api_key=Tc6JbbBVQfA&fields=name,description';

      var extend = {
        "ChildCollection": {
          "fields": "name,desc",
          "params": {
          }
        },
        "ChildCount": {
          "fields": "total,collection",
          "params": {
          }
        }
      };

      var extendStr = "extend=" + JSON.stringify(extend);
      var request = initEp + "&" + extendStr;

      axios
        .get(request)
        .then(response => {
          this.galleries = response.data.data.Children;
          // console.log(this.galleries);
        })

    }
  }

</script>

<style lang="scss" scoped>

  @import '../assets/scss/_variables';
  @import '../assets/scss/_include-media';
  @import '../assets/scss/components/_admin-collection';
  
</style>



// WEBPACK FOOTER //
// src/components/admin.vue